import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/stock_lines'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: [
      {
        id: null,
        notes: null,
        entry_amount: null,
        entry_amount_orginal: null,
        output_amount: null,
        price: null,
        units: null,
        invoice_number: null,
        id_projects: null,
        id_warehouses: null,
        id_suppliers: null,
        id_stocks: null,
        id_currencies: null,
        id_users: null,
        submitData: false,
      },
    ],
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM_QUICK(state) {
      state.dataItem = [{
        id: null,
        entry_amount: null,
        entry_amount_orginal: null,
        output_amount: null,
        price: null,
        units: null,
        invoice_number: null,
        id_projects: null,
        id_warehouses: null,
        id_suppliers: null,
        id_stocks: null,
        id_users: null,
        submitData: false,
      }]
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        notes: null,
        entry_amount: null,
        entry_amount_orginal: null,
        output_amount: null,
        price: null,
        invoice_number: null,
        id_projects: null,
        id_warehouses: null,
        id_suppliers: null,
        id_stocks: null,
        id_users: null,
        submitData: false,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'stock_lines.id': id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    batchInsert({ commit }, postData) {
      const data = JSON.stringify(postData)
      return axiosIns
        .post(`${ROOT_URL}/batchInsert`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
